var _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 81,
    viewBox: "0 0 129 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.439 0H2.48413C1.66447 0 1 0.834289 1 1.86344V78.4523C1 79.4815 1.66447 80.3158 2.48413 80.3158H112.439C113.259 80.3158 113.923 79.4815 113.923 78.4523V1.86344C113.923 0.834289 113.259 0 112.439 0Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.271 1.13086H2.66186C1.8422 1.13086 1.17773 1.96515 1.17773 2.9943V78.1867C1.17773 79.2159 1.8422 80.0502 2.66186 80.0502H112.271C113.091 80.0502 113.755 79.2159 113.755 78.1867V2.9943C113.755 1.96515 113.091 1.13086 112.271 1.13086Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.423 1.13086H2.85093C1.92685 1.13086 1.17773 1.96515 1.17773 2.9943V78.1867C1.17773 79.2159 1.92685 80.0502 2.85093 80.0502H126.423C127.347 80.0502 128.097 79.2159 128.097 78.1867V2.9943C128.097 1.96515 127.347 1.13086 126.423 1.13086Z",
    fill: "white",
    stroke: "#D4DBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.255 0.223633H1.82303C1.65241 0.223633 1.48877 0.299241 1.36812 0.433822C1.24747 0.568403 1.17969 0.750933 1.17969 0.941259V3.97438H127.893V0.941259C127.893 0.751963 127.826 0.570329 127.707 0.435919C127.587 0.301508 127.425 0.225207 127.255 0.223633Z",
    fill: "#7E49DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118 24H12V70H118V24Z",
    fill: "#D4DBFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.4121,
    cy: 14.8134,
    r: 5.30268,
    fill: "#6020D4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.332 13.9102H23.6016V16.7314H34.332V13.9102Z",
    fill: "#6020D4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4108 17.3389L11.9099 14.7776L14.4124 12.3244V11.3828L10.9805 14.7463L14.4108 18.2451V17.3389Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4121 17.3389L16.9131 14.7776L14.4121 12.3244V11.3828L17.8425 14.7463L14.4121 18.2451V17.3389Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4115 15.2108L13.9883 14.7817L14.5127 14.25L14.936 14.6791L14.4115 15.2108Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7447 14.4205L15.3862 14.7839L14.4117 15.7719L13.4373 14.7839L14.7702 13.4325L14.3455 13.002L12.5879 14.7839L14.4117 16.6329L15.8112 15.2142L16.1694 14.851L15.7447 14.4205Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.04789 3.06843C4.58347 3.06843 5.01765 2.63425 5.01765 2.09867C5.01765 1.56308 4.58347 1.12891 4.04789 1.12891C3.5123 1.12891 3.07812 1.56308 3.07812 2.09867C3.07812 2.63425 3.5123 3.06843 4.04789 3.06843Z",
    fill: "#04AAF0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66117 3.06746C7.19675 3.06746 7.63093 2.63328 7.63093 2.09769C7.63093 1.56211 7.19675 1.12793 6.66117 1.12793C6.12558 1.12793 5.69141 1.56211 5.69141 2.09769C5.69141 2.63328 6.12558 3.06746 6.66117 3.06746Z",
    fill: "#49DBA3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27054 3.06746C9.80613 3.06746 10.2403 2.63328 10.2403 2.09769C10.2403 1.56211 9.80613 1.12793 9.27054 1.12793C8.73496 1.12793 8.30078 1.56211 8.30078 2.09769C8.30078 2.63328 8.73496 3.06746 9.27054 3.06746Z",
    fill: "#F34258"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0012 41.7302H70.1984V38.2506C70.1984 34.324 67.0479 31.0599 63.0965 31.0004C62.1436 30.9904 61.1982 31.168 60.3148 31.5227C59.4313 31.8775 58.6272 32.4025 57.9489 33.0675C57.2705 33.7325 56.7313 34.5243 56.3623 35.3973C55.9933 36.2703 55.8019 37.2072 55.7989 38.154V41.7302H54.0002C53.2052 41.7327 52.4435 42.0475 51.8814 42.6061C51.3193 43.1647 51.0025 43.9215 51 44.7115V59.0188C51.0025 59.8087 51.3193 60.5656 51.8814 61.1241C52.4435 61.6827 53.2052 61.9976 54.0002 62H72.0012C72.796 61.9976 73.5575 61.6826 74.1194 61.124C74.6813 60.5654 74.9979 59.8086 75 59.0188V44.7115C74.9979 43.9217 74.6813 43.1648 74.1194 42.6062C73.5575 42.0476 72.796 41.7327 72.0012 41.7302ZM64.0517 51.0309V56.1552C64.0535 56.4265 63.9514 56.6884 63.7661 56.8877C63.5808 57.087 63.3262 57.2089 63.0539 57.2287C62.9117 57.2353 62.7697 57.2132 62.6363 57.1637C62.503 57.1142 62.3812 57.0383 62.2782 56.9407C62.1752 56.8431 62.0932 56.7257 62.0372 56.5957C61.9812 56.4657 61.9523 56.3257 61.9523 56.1843V51.0282C61.4655 50.7924 61.0736 50.3996 60.8405 49.9139C60.6074 49.4282 60.5467 48.8784 60.6685 48.3541C60.7904 47.8298 61.0874 47.362 61.5112 47.027C61.935 46.692 62.4605 46.5096 63.002 46.5096C63.5435 46.5096 64.069 46.692 64.4928 47.027C64.9166 47.362 65.2136 47.8298 65.3354 48.3541C65.4572 48.8784 65.3966 49.4282 65.1635 49.9139C64.9303 50.3996 64.5384 50.7924 64.0517 51.0282V51.0309ZM68.1016 41.7302H57.8984V38.154C57.8984 36.8101 58.4357 35.5212 59.392 34.5708C60.3484 33.6205 61.6455 33.0866 62.998 33.0866C64.3505 33.0866 65.6476 33.6205 66.604 34.5708C67.5603 35.5212 68.0976 36.8101 68.0976 38.154L68.1016 41.7302Z",
    fill: "#3F1788"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 57.461,
    y1: 80.3158,
    x2: 57.461,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafe);
export default __webpack_public_path__ + "static/media/Safe.19dfed1e08c412c8a1a12b6a37ab7e52.svg";
export { ForwardRef as ReactComponent };